<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 197.21"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            :class="{active:blocks.root}"
            @click="select('root')"
            v-if="!noSegments"
            cx="45.267"
            cy="112.175"
            r="9.984"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.first}"
            @click="select('first')"
            v-if="!noSegments"
            d="M64.532 187.343c-8.724,-7.331 -18.451,-7.478 -28.88,-0.723 3.945,4.144 8.826,6.657 14.171,6.83 5.42,0.176 10.52,-2.081 14.761,-6.063 -0.017,-0.015 -0.034,-0.029 -0.052,-0.044z"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            v-if="!noSegments"
            d="M32.523 134.338c8.327,11.046 22.354,13.162 41.672,5.773 0.048,-0.018 0.098,-0.038 0.147,-0.056 -0.187,-0.54 -0.392,-1.068 -0.615,-1.583 -0.7,-1.619 -1.524,-3.138 -2.453,-4.545 -4.635,-7.029 -11.859,-11.284 -19.147,-11.519 -7.693,-0.249 -14.738,4.401 -19.604,11.93z"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            v-if="!noSegments"
            d="M42.743 183.054l-0.478 -40.87c-1.484,-0.654 -2.882,-1.45 -4.193,-2.386 -2.1,-1.444 -3.979,-3.224 -5.629,-5.334 -1.152,1.798 -2.179,3.758 -3.062,5.853 -2.091,4.962 -3.372,10.681 -3.571,16.796 -0.391,12.072 3.53,22.876 9.842,29.507 2.405,-1.557 4.772,-2.748 7.091,-3.566z"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            v-if="!noSegments"
            d="M62.21 143.615c-4.069,26.372 -5.917,34.501 -8.016,38.472 3.579,0.73 7.031,2.477 10.338,5.256 0.018,0.015 0.035,0.029 0.052,0.044 6.632,-6.228 11.168,-16.676 11.556,-28.642 0.213,-6.613 0.087,-13.244 -1.798,-18.69 -0.049,0.018 -0.099,0.038 -0.147,0.056 -0.008,0.003 -0.015,0.006 -0.022,0.009 -4.245,1.622 -8.234,2.785 -11.963,3.495z"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.six}"
            @click="select('six')"
            v-if="!noSegments"
            d="M54.194 182.087c2.099,-3.972 3.947,-12.101 8.016,-38.472 -7.793,1.484 -14.45,0.99 -19.934,-1.425l0.474 40.862c3.938,-1.389 7.758,-1.716 11.444,-0.965z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M76.14 158.745c0.235,-7.268 0.059,-14.559 -2.413,-20.273 -4.198,-9.709 -12.853,-15.782 -21.6,-16.064 -13.897,-0.45 -25.68,15.087 -26.317,34.705 -0.636,19.617 10.115,35.886 24.013,36.337 13.897,0.451 25.681,-15.088 26.317,-34.705zm-4.865 -24.818c-3.853,-33.481 -9.179,-61.335 -19.819,-88.372 -5.329,-13.541 -14.743,-13.844 -15.985,1.177 -3.05,36.877 2.998,57.776 -6.09,93.585"
        />
        <circle
            class="fil1 str1"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            v-if="!noSegments"
            cx="36.047"
            cy="32.683"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
